export let decemberAbbreviatedLowercase = "TO22te";
export default {decemberAbbreviatedLowercase};